import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User as UserIcon, LayoutDashboard, BookOpen, Heart, Award, Tv } from "lucide-react";

export default function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isAdmin = user?.role === "administrador";

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FFF9ED]/85 border-b border-[#243B53]/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-3 flex items-center gap-4">
        <Link to={user ? "/app" : "/"} data-testid="brand-link" className="flex items-center gap-2 group">
          <span className="relative inline-flex items-center justify-center">
            <span className="text-2xl">🌟</span>
            <span className="absolute -bottom-1 left-0 right-0 h-1 rounded-full rainbow-strip opacity-90" />
          </span>
          <span className="font-extrabold text-[#243B53] text-lg sm:text-xl">Clubinho da Fé</span>
        </Link>

        {user && (
          <nav className="ml-auto hidden md:flex items-center gap-1">
            <NavItem to="/app" icon={<LayoutDashboard size={18} />} label="Início" testid="nav-home" />
            <NavItem to="/library" icon={<BookOpen size={18} />} label="Biblioteca" testid="nav-library" />
            <NavItem to="/series" icon={<Tv size={18} />} label="Séries" testid="nav-series" />
            <NavItem to="/journeys" icon={<span>🧭</span>} label="Jornadas" testid="nav-journeys" />
            <NavItem to="/favorites" icon={<Heart size={18} />} label="Favoritos" testid="nav-favorites" />
            <NavItem to="/passport" icon={<Award size={18} />} label="Passaporte" testid="nav-passport" />
            <NavItem to="/parents" icon={<span>👨‍👩‍👧</span>} label="Área dos Pais" testid="nav-parents" />
            <NavItem to="/profile" icon={<UserIcon size={18} />} label="Perfil" testid="nav-profile" />
            {isAdmin && <NavItem to="/admin" icon={<span>🛠️</span>} label="Admin" testid="nav-admin" />}
          </nav>
        )}

        <div className="ml-auto md:ml-0 flex items-center gap-2">
          {!user && (
            <>
              <Link to="/login" data-testid="header-login-btn" className="btn-outline text-sm">Entrar</Link>
              <Link to="/assinatura" data-testid="header-subscription-btn" className="btn-primary text-sm">Assinar</Link>
            </>
          )}
          {user && (
            <button data-testid="header-logout-btn" onClick={doLogout} className="btn-outline text-sm flex items-center gap-2">
              <LogOut size={16} /> <span className="hidden sm:inline">Sair</span>
            </button>
          )}
        </div>
      </div>
      {user && (
        <div className="md:hidden max-w-7xl mx-auto px-3 pb-2 flex flex-wrap gap-1">
          <NavItem to="/app" label="Início" testid="mnav-home" small />
          <NavItem to="/library" label="Biblioteca" testid="mnav-library" small />
          <NavItem to="/series" label="Séries" testid="mnav-series" small />
          <NavItem to="/journeys" label="Jornadas" testid="mnav-journeys" small />
          <NavItem to="/favorites" label="Favoritos" testid="mnav-favorites" small />
          <NavItem to="/passport" label="Passaporte" testid="mnav-passport" small />
          <NavItem to="/parents" label="Área dos Pais" testid="mnav-parents" small />
          <NavItem to="/profile" label="Perfil" testid="mnav-profile" small />
          {isAdmin && <NavItem to="/admin" label="Admin" testid="mnav-admin" small />}
        </div>
      )}
    </header>
  );
}

function NavItem({ to, icon, label, testid, small }) {
  return (
    <NavLink
      to={to}
      data-testid={testid}
      className={({ isActive }) =>
        `${small ? "px-3 py-1 text-xs" : "px-3 py-2 text-sm"} rounded-full font-bold transition ${
          isActive ? "bg-[#FFD54F] text-[#243B53]" : "text-[#243B53]/80 hover:bg-white"
        }`
      }
    >
      <span className="inline-flex items-center gap-1.5">{icon} {label}</span>
    </NavLink>
  );
}
